/* Mahlgrad Guide – Erklär-Fenster für Fachbegriffe.
   Wird von der Section „MG Erklärungen“ geladen. Begriffe, Erklärungen und
   Fundstellen kommen aus deren Blöcken. */
(function () {
  if (window.__mahlgradGlossJs) return;
  window.__mahlgradGlossJs = true;
  function activeMethod() { var b = document.querySelector('.mg-methoden .mg-brew.is-on'); return b ? b.getAttribute('data-id') : null; }
  /* Erklär-Fenster: Begriffe aus der Section „MG Erklärungen“ im Text markieren */
  var GL = null, pop = null, openBtn = null, pinned = false, hoverT;
  var SKIP = 'a,button,summary,h1,h2,h3,script,style,svg,textarea,.mg-glossar,.mg-mbtn,[data-out]';
  function list(v) { return (v || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  function esc(w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function loadGloss() {
    var root = document.querySelector('.mg-glossar'), data = root && root.querySelector('.mg-gloss-data');
    if (!data) return null;
    var terms; try { terms = JSON.parse(data.textContent); } catch (e) { return null; }
    var cs = getComputedStyle(root);
    var g = { root: root, warn: root.getAttribute('data-warn') || 'Worauf achten', byId: {}, terms: [],
      vars: { bg: cs.getPropertyValue('--mg-pop-bg'), fg: cs.getPropertyValue('--mg-pop-fg'), ac: cs.getPropertyValue('--mg-pop-accent') } };
    terms.forEach(function (t, i) {
      t.key = t.id || ('t' + i);
      var notes = {};
      (t.m || '').split(/\n/).forEach(function (line) { var k = line.indexOf(':'); if (k > 0) notes[line.slice(0, k).trim()] = line.slice(k + 1).trim(); });
      t.notes = notes;
      t.labelList = list(t.labels);
      var ws = list(t.words).sort(function (a, b) { return b.length - a.length; });
      t.re = ws.length ? new RegExp('(^|[^\\p{L}\\p{N}-])(' + ws.map(esc).join('|') + ')(?![\\p{L}\\p{N}])', 'u') : null;
      t.scopes = list(t.scope);
      g.byId[t.key] = t; g.terms.push(t);
    });
    return g;
  }
  function makeBtn(t, text) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'mg-term'; b.setAttribute('data-term', t.key);
    b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', 'mg-gloss');
    b.textContent = text; return b;
  }
  /* Ersetzt einen Textknoten durch genau ein Element. So bleibt die Zahl der Kinder gleich,
     und Grid- oder Flex-Layouts (z. B. die nummerierten Schritte) verschieben sich nicht. */
  function wrap(before, btn, after) {
    var s = document.createElement('span'); s.className = 'mg-term-wrap';
    if (before) s.appendChild(document.createTextNode(before));
    s.appendChild(btn);
    if (after) s.appendChild(document.createTextNode(after));
    return s;
  }
  function textNodes(scope) {
    var out = [], w = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        return n.parentElement && n.parentElement.closest(SKIP) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    while (w.nextNode()) out.push(w.currentNode);
    return out;
  }
  function markSection(sec) {
    if (sec.__mgGloss) return; sec.__mgGloss = true;
    var id = sec.id;
    GL.terms.forEach(function (t) {
      if (t.scopes.length && t.scopes.indexOf(id) < 0) return;
      var done = [];
      textNodes(sec).forEach(function (n) {
        if (!n.parentNode || (n.parentElement && n.parentElement.closest('.mg-term'))) return;
        var raw = n.nodeValue, trimmed = raw.trim();
        if (t.labelList.indexOf(trimmed) >= 0) {
          var at = raw.indexOf(trimmed);
          var b = makeBtn(t, trimmed); b.classList.add('is-label');
          n.parentNode.replaceChild(wrap(raw.slice(0, at), b, raw.slice(at + trimmed.length)), n);
          return;
        }
        if (!t.re) return;
        var box = (n.parentElement && n.parentElement.closest('.mg-brew')) || sec;
        if (done.indexOf(box) >= 0) return;
        var m = t.re.exec(raw); if (!m) return;
        var start = m.index + m[1].length, word = m[2];
        n.parentNode.replaceChild(wrap(raw.slice(0, start), makeBtn(t, word), raw.slice(start + word.length)), n);
        done.push(box);
      });
    });
  }
  function ensurePop() {
    if (pop) return;
    pop = document.createElement('div'); pop.className = 'mg-gloss-pop'; pop.id = 'mg-gloss'; pop.setAttribute('role', 'tooltip'); pop.hidden = true;
    pop.addEventListener('mouseenter', function () { clearTimeout(hoverT); });
    pop.addEventListener('mouseleave', function () { if (!pinned) hoverT = setTimeout(hide, 160); });
    pop.addEventListener('click', function (e) { e.stopPropagation(); });
    document.body.appendChild(pop);
  }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt) e.textContent = txt; return e; }
  function build(btn) {
    var t = GL.byId[btn.getAttribute('data-term')]; if (!t) return false;
    pop.textContent = '';
    if (GL.vars.bg) pop.style.setProperty('--gl-bg', GL.vars.bg);
    if (GL.vars.fg) pop.style.setProperty('--gl-fg', GL.vars.fg);
    if (GL.vars.ac) pop.style.setProperty('--gl-ac', GL.vars.ac);
    pop.appendChild(el('p', 'gl-h', t.t || btn.textContent));
    if (t.d) pop.appendChild(el('p', '', t.d));
    if (t.w) { var w = el('div', 'gl-warn'); w.appendChild(el('b', '', GL.warn)); w.appendChild(document.createTextNode(t.w)); pop.appendChild(w); }
    var extra = btn.closest('.mg-finder') ? t.notes[activeMethod()] : t.x;
    if (extra) pop.appendChild(el('p', 'gl-ctx', extra));
    return true;
  }
  function place(btn) {
    var r = btn.getBoundingClientRect(), pw = pop.offsetWidth, ph = pop.offsetHeight, vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var cx = r.left + r.width / 2, left = Math.min(Math.max(16, cx - pw / 2), vw - 16 - pw);
    var below = (r.bottom + 10 + ph <= vh - 8) || (r.top - 10 - ph < 8);
    pop.classList.toggle('below', below); pop.classList.toggle('above', !below);
    pop.style.left = left + 'px'; pop.style.top = (below ? r.bottom + 10 : r.top - 10 - ph) + 'px';
    pop.style.setProperty('--ax', Math.min(Math.max(14, cx - left), pw - 14) + 'px');
  }
  function show(btn, pin) {
    ensurePop();
    if (openBtn && openBtn !== btn) openBtn.setAttribute('aria-expanded', 'false');
    if (!build(btn)) return;
    openBtn = btn; pinned = !!pin; pop.hidden = false; btn.setAttribute('aria-expanded', 'true'); place(btn);
  }
  function hide() { if (!openBtn) return; openBtn.setAttribute('aria-expanded', 'false'); openBtn = null; pinned = false; pop.hidden = true; }
  function initGloss(force) {
    if (force || !GL) GL = loadGloss();
    if (!GL) return;
    document.querySelectorAll('.mg[id]').forEach(function (sec) { if (!sec.classList.contains('mg-glossar')) markSection(sec); });
  }
  if (!window.__mahlgradGloss) {
    window.__mahlgradGloss = true;
    var canHover = !!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches);
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.mg-term');
      if (b) { e.preventDefault(); e.stopPropagation(); clearTimeout(hoverT); if (openBtn === b && pinned) hide(); else show(b, true); return; }
      hide();
    }, true);
    if (canHover) {
      document.addEventListener('mouseover', function (e) {
        var b = e.target.closest && e.target.closest('.mg-term'); if (!b || pinned) return;
        clearTimeout(hoverT); hoverT = setTimeout(function () { show(b, false); }, 120);
      });
      document.addEventListener('mouseout', function (e) {
        var b = e.target.closest && e.target.closest('.mg-term'); if (!b || pinned) return;
        clearTimeout(hoverT); hoverT = setTimeout(hide, 160);
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openBtn) { var b = openBtn; hide(); b.focus(); } });
    window.addEventListener('scroll', function () { if (openBtn) place(openBtn); }, { passive: true, capture: true });
    window.addEventListener('resize', function () { if (openBtn) place(openBtn); });
  }

  function start() { initGloss(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { hide(); initGloss(true); });
})();
